import { IS_EMAIL } from "@constants";

export function isEmail(value: string): Error | undefined {
  if (!IS_EMAIL.test(value)) {
    return new Error("Invalid email");
  }
}
